import React from 'react';
import { renderToString } from 'react-dom/server';
import { number_with_delimiter as numberWithDelimiter } from 'number_helpers';
import { isNumber } from 'lodash-es';

import defaultLineChartConfig from '../../../../../../components/Chart/LineChart';
import navigatorOptions from '../../../../../../components/Chart/ChartNavigator';
import { showZoomButtonsEvent } from '../../../../../../utils/charts/options';
import { numberToPercentage } from '../../../../../../utils/formatter';

export const colorsBySeries = {
  kpi: '#EA5782',
  forecast: '#348BE3',
};

export const namesBySeries = {
  kpi: 'Company Reported',
  forecast: 'Apptopia Forecast',
};

export const makeChartConfig = ({ categories, view, isScreenshot = false, onChartZoomChange }) =>
  defaultLineChartConfig({
    chartOptions: {
      height: 270,
      spacing: isScreenshot ? [10, 10, 4, 10] : [10, 0, 4, 0],
      zooming: {
        // supported in highcharts v10.2.1
        type: 'x',
      },
      zoomType: 'x', // deprecated since highcharts v10.2.1
    },
    xAxisOptions: {
      labels: {
        y: 30,
        formatter() {
          return categories[this.pos];
        },
        style: {
          color: '#363D54',
          fontSize: 12,
        },
      },
      tickLength: 0,
      events: showZoomButtonsEvent(() => {}, [onChartZoomChange]),
    },
    yAxisOptions: {
      gridLineColor: '#E1E5EB',
      gridLineWidth: 1,
      startOnTick: true,
      endOnTick: true,
      opposite: false,
      showLastLabel: true,
    },
    ...(view === 'change'
      ? { labelValue: (value) => numberToPercentage(value, { precision: 0 }) }
      : {}),
    yAxisLabels: {
      style: {
        color: '#363D54',
        fontSize: 11,
      },
    },
    plotOptionsSeries: {
      animation: !isScreenshot,
    },
    tooltipOptions: {
      backgroundColor: 'transparent',
      borderWidth: 0,
      borderRadius: 0,
      padding: 0,
      shared: true,
      outside: true,
      shadow: false,
      style: {
        color: '#363D54',
        fontSize: 12,
      },
      useHTML: true,
      formatter() {
        let rows;

        if (Array.isArray(this.points)) {
          // Rows
          rows = this.points.map((point) =>
            renderToString(
              <tr>
                <td className="v-a-m text-left text-12 p-t-xxxs p-r-mdl p-b-0 p-l-0">
                  <span className="l-h-md">
                    {point.series.name === 'Apptopia Forecast' ? (
                      <b>Apptopia Forecast</b>
                    ) : (
                      point.series.name
                    )}
                  </span>
                </td>
                <td className="v-a-m text-right text-12 p-t-xxxs p-r-0 p-b-0 p-l-0">
                  {view === 'change' ? (
                    <span className="l-h-md">
                      {Math.round(point.y)}%{' '}
                      <span className="text-bold" style={{ fontSize: 9 }}>
                        YoY
                      </span>
                    </span>
                  ) : (
                    <span className="l-h-md">{numberWithDelimiter(point.y)}</span>
                  )}
                </td>
              </tr>
            )
          );
        } else return false;

        return `
        <div class="series-tooltip bg-white b-a b-rds-8" style="padding: 8px 16px;box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.16);">
          <span class="l-h-md d-inline-block"><b>${
            isNumber(this.x) ? categories[this.x] : this.x
          }</b></span>
          <table class="table">${rows.join('')}</table>
        </div>
      `;
      },
    },
    ...navigatorOptions({
      margin: 14,
    }),
    scrollbar: {
      enabled: true,
      buttonBackgroundColor: 'white',
      buttonBorderWidth: 0,
      buttonArrowColor: 'white',
      buttonBorderRadius: 0,
      height: 0,
    },
  });
